const STORAGE_KEY = "dd_home_screen_prompt"

export type HomeScreenPromptState = "pending" | "dismissed" | "installed"

export function isStandaloneDisplay(): boolean {
  if (typeof window === "undefined") return false
  const mediaStandalone =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(display-mode: standalone)").matches
  const iosStandalone =
    "standalone" in navigator &&
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
  return Boolean(mediaStandalone || iosStandalone)
}

export function isIosDevice(): boolean {
  if (typeof navigator === "undefined") return false
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export function readHomeScreenPromptState(): HomeScreenPromptState | null {
  if (typeof window === "undefined") return null
  const value = window.localStorage.getItem(STORAGE_KEY)
  if (value === "pending" || value === "dismissed" || value === "installed") return value
  return null
}

export function writeHomeScreenPromptState(state: HomeScreenPromptState): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(STORAGE_KEY, state)
}

/** Mark the install banner as pending after first email verification. */
export function markHomeScreenPromptPending(): void {
  const current = readHomeScreenPromptState()
  if (current === "dismissed" || current === "installed") return
  writeHomeScreenPromptState("pending")
}

export function shouldShowHomeScreenPrompt(): boolean {
  if (isStandaloneDisplay()) return false
  return readHomeScreenPromptState() === "pending"
}
